import React from 'react';
import HeaderForm from './form';
import {getBreadCrumbs, updateBreadCrumbsItem,updateProductItem} from '../../modules/Api';
import {normalizer, prepareForEdit} from '../Coupons/pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

class EditBreadCrumbs extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        const ads_id = this.props.match.params.id;
        getBreadCrumbs(ads_id, data => {this.setState({data: prepareForEdit(data)})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const ads_id = this.props.match.params.id;
        const formData = normalizer(values, this.state.data);
        updateBreadCrumbsItem(ads_id, formData, () => {
            notification.open({
                message: `برید کرامبز با موفقیت ویرایش شد!`,
                description: ``
            });
            this.setState({submitted: false});
            history.item.push(`/bread-crumbs`);
        })
    }
    render() {
        if(!this.state.data.id){
            return (<div>لطفا منتظر بمانید</div>);
        }
        return (<div><HeaderForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditBreadCrumbs;


// WEBPACK FOOTER //
// ./src/containers/BreadCrumbs/edit.js